module.exports = __webpack_public_path__ + "static/media/misroute_icon.102985d2.png";